import script from "./Rota.vue?vue&type=script&lang=js"
export * from "./Rota.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__